import {RecordForm} from '../forms/RecordForm';


import {usePipeline} from '../hooks/usePipeline.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {useNavigate} from "react-router-dom";


export const AddPage = () => {

    const navigate = useNavigate();

    const {
        record,
        createRecord,
    } = usePipeline();

    return (
        <FormPageLayout
            title='Add Pipeline'
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm record={record || {} as any} handleSubmit={createRecord} handleCancel={() => navigate('/pipelines')}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
